import React, { useEffect, useState } from 'react'
import { colors } from '@lib/colors'
import { Image, View, StyleSheet } from 'react-native'
import { TextInput } from 'react-native-web'
import Button from './Button'

interface PhotoPreviewProps {
  photo: any
  onClose: () => void
  onUpdate: (photo: Photo) => void
}

export default function ({ photo, onClose, onUpdate }: PhotoPreviewProps) {
  const [description, setDescription] = useState<string | undefined>()

  useEffect(() => {
    if (photo.description) setDescription(photo.description)
  }, [])

  function updatePhoto () {
    onUpdate({ ...photo, description })
    onClose()
  }

  return (
    <View style={styles.container}>
      <View style={styles.inner}>
        <View style={{ overflow: 'hidden', flex: 2 }}>
          <Image source={{ uri: photo?.uri }} style={ styles.photoPreview } resizeMode={ 'contain' }/>
        </View>
        <TextInput
          placeholder="Photo Description"
          style={styles.textInput}
          textAlignVertical={'top'}
          onChangeText={setDescription}
          value={description}
          multiline
        />
        <View style={styles.btnContainer}>
          <Button
            label="Save"
            onPress={updatePhoto}
            buttonStyles={{ backgroundColor: colors.green[400] }}
          />

          <Button
            label="Cancel"
            onPress={onClose}
            buttonStyles={{ backgroundColor: colors.gray[50], marginTop: 10 }}
            textStyles={{ color: colors.gray[400] }}
          />
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: colors.white,
    width: '100%',
    height: '100%',
    borderRadius: 3,
    elevation: 30,
  },
  inner: {
    padding: 24,
    flex: 1,
    justifyContent: 'flex-start',
    shadowColor: colors.black,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.05,
    shadowRadius: 4.65,
  },
  header: {
    fontSize: 36,
    marginBottom: 48,
  },
  photoContainer: {
    overflow: 'hidden',
    flex: 1,
  },
  photoPreview: {
    width: '100%',
    minHeight: 500,
  },
  textInput: {
    backgroundColor: colors.gray['50'],
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: 4,
    height: 90,
    marginTop: 10,
  },
  btnContainer: {
    backgroundColor: colors.white,
    marginTop: 12,
  },
})
